import React from 'react';
import { BrowserRouter as Router, Routes, Route, useParams, Navigate } from 'react-router-dom';
import Viewer from './Viewer';
import './App.css';

function QRRedirect() {
  const { code } = useParams();
  
  // Map QR codes to project IDs
  const qrMap = {
    'auntdot1909': 'auntdot',
    'livandpops2003': 'livandpops'  // for future
  };
  
  const projectId = qrMap[code];
  
  if (!projectId) {
    return <div style={{padding: '2rem', textAlign: 'center'}}>
      <h1>QR Code Not Found</h1>
      <p>Code: {code}</p>
    </div>;
  }
  
  return <Viewer projectId={projectId} />;
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/qr/:code" element={<QRRedirect />} />
        <Route path="/" element={<Viewer projectId="auntdot" />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}

export default App;